import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=c2cd1212&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=c2cd1212&prod&scoped=true&lang=css"
import style1 from "./Company.vue?vue&type=style&index=1&id=c2cd1212&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cd1212",
  null
  
)

export default component.exports